export default __webpack_public_path__ + "static/media/Astro_Mercury_Black.77ec296b.png";